// extracted by mini-css-extract-plugin
export default {"counterWrapper":"Stats_counterWrapper__LifIC","counterContent":"Stats_counterContent__+FVIX"};